import { QUERY_KEYS } from 'api/query-keys';
import { DateTime } from 'luxon';
import { useSiteDetection } from 'shared/hooks';
import { useInfiniteQuery } from 'react-query';
import { CACHE_TIME_LONG } from 'shared/react-query/query-defaults';
import { availabilityService } from 'api/services';

export const useGetAvailablePartnerWorkers = (params: {
  search: string | undefined;
  fromDate: DateTime;
  pageSizeParam: number;
}) => {
  const { site } = useSiteDetection();

  return useInfiniteQuery({
    queryKey: QUERY_KEYS.workersAvailability(params.search, params.fromDate.toISODate()),
    queryFn: async ({ pageParam = 0 }) => {
      return await availabilityService.getWorkersAvailability({
        ...params,
        fromDate: params.fromDate.toISODate(),
        site,
        pageParam,
      });
    },
    cacheTime: CACHE_TIME_LONG,
    staleTime: CACHE_TIME_LONG,
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.hasNextPage) {
        return allPages.length;
      }
      return undefined;
    },
  });
};
